import { Validators } from '@angular/forms';

import { FundOrderStatusesEnum } from '@spa/api';

import { Helper, RadioGroupControl } from '../../app/shared/classes';
import { RadioGroupOptionInterface } from '../../app/shared/components';
import { ColorCodesEnum, ComponentTypesEnum } from '../../app/shared/enums';

export const OrderStatusSelector = 'orderStatus';

export const OrderStatusesControl = (): RadioGroupControl => {
    return new RadioGroupControl({
        name: OrderStatusSelector,
        value: null,
        placeholder: 'Status',
        validators: [Validators.required],
        componentType: ComponentTypesEnum.RadioGroup,
        invalid: false,
        errors: [],
        options: []
    });
};

export const OrderStatusControlFundingOptions = (): RadioGroupOptionInterface[] => {
    return [
        {
            label: Helper.textsHelper().getOrderStatusName(FundOrderStatusesEnum.New),
            value: FundOrderStatusesEnum.New,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getOrderStatusName(FundOrderStatusesEnum.Pending),
            value: FundOrderStatusesEnum.Pending,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getOrderStatusName(FundOrderStatusesEnum.Matched),
            value: FundOrderStatusesEnum.Matched,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getOrderStatusName(FundOrderStatusesEnum.Rejected),
            value: FundOrderStatusesEnum.Rejected,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getOrderStatusName(FundOrderStatusesEnum.Completed),
            value: FundOrderStatusesEnum.Completed,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getOrderStatusName(FundOrderStatusesEnum.Problematic),
            value: FundOrderStatusesEnum.Problematic,
            color: ColorCodesEnum.Primary
        }
    ];
};
